import PaperButton from "components/buttons/PaperButton";
import CustomLink from "components/CustomLink";
import CustomTable from "components/CustomTable";
import ExportReactCSV from "components/ExportReactCSV";
import CustomText from "components/typography/CustomText";
import { currency } from "lib/formatter";
import moment from "moment";

export default function CustomersTable({
  data = [],
  onLoadData = () => {},
  totalPage = 1,
  page = 1,
}) {
  const headers = [
    { label: "ID", key: "id" },
    { label: "Email", key: "email" },
    { label: "Name", key: "name" },
    { label: "phone", key: "phone" },
    { label: "Verify", key: "verify" },
    { label: "Total Spent", key: "total_spent" },
  ];
  const customers = () => {
    let custs = data.map((row) => ({
      id: row?.id ?? "",
      email: row?.email,
      name: row?.name ?? "",
      phone: row?.phone ?? "",
      verify: row?.verify ?? false,
      total_spent: currency.format(row?.price),
    }));
    return custs;
  };

  const handleChangePage = (p, sortKey) => {
    onLoadData({ page: p, sortKey });
  };

  const handleSortKey = (sortKey) => {
    onLoadData({ sortKey, page });
  };

  return (
    <div className="py-5">
      <CustomTable
        data={data}
        height={600}
        pageCount={20}
        isPageActive={true}
        page={page}
        totalPage={totalPage}
        onChangePage={handleChangePage}
        onSortKey={handleSortKey}
        toolbar={
          <div className="p-4 border-b border-white-gray flex justify-between items-center">
            <CustomText variant="h6" bold={600}>
              Customers
            </CustomText>
            <ExportReactCSV
              csvHeaders={headers}
              csvData={customers()}
              fileName={`customers.csv`}
            />
          </div>
        }
        columns={[
          {
            label: "E-MAIL",
            selector: "email",
            cell: (row) => (
              <PaperButton variant="text" color="primary">
                {row?.email}
              </PaperButton>
            ),
          },
          { label: "NAME", selector: "name" },
          {
            label: "JOIN DATE",
            selector: "created_at",
            sortValue: (row) => moment(row?.created_at).unix(),
            cell: (row) => (
              <PaperButton variant="text" color="primary">
                {moment(row?.created_at).format("MM/DD/YY")}
              </PaperButton>
            ),
          },
          {
            label: "TOTAL SPENT",
            selector: "total",
            sortValue: (row) => +row?.total ?? 0,
            cell: (row) => currency.format(row?.total),
          },
          {
            label: "",
            selector: "actions",
            cell: (row, rowIndex) => (
              <div className="flex items-center">
                <CustomLink to={`/customers/${row?.id ?? ""}`}>
                  <PaperButton variant="text" color="primary">
                    View Customer
                  </PaperButton>
                </CustomLink>
              </div>
            ),
          },
        ]}
      />
    </div>
  );
}
